module.exports = __webpack_public_path__ + "static/adam-agee.bfa4f8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/adam-agee.jpg
// module id = 1297
// module chunks = 168707334958949